import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { MessageService } from '../message.service';
import { ModuleListModel } from './master-list-model';


@Injectable({
  providedIn: 'root'
})
export class ModuleService extends BaseService {

  private wsBase: string =  "/module/";

  constructor(http: HttpClient, messageService:MessageService) {
    super(http, messageService);
  }

  loadModuleList(page: number):Observable<ModuleListModel> 
  {
    var url = this.wsUrl(this.wsBase) + "list?"+"page="+page;
    return this.dataGET(url);
  }

 
}
